type Options = {
  noEdit?: boolean
  noSkip?: boolean
}

export const useInterfaces = (options: Options) => {
  const { noEdit, noSkip } = options

  // panel, topbar and controls are no more needed due to custom implementation of the skip, update buttons
  const base = ['side-column', 'instruction']
  const skip = noSkip ? [] : ['skip']
  const edit = noEdit ? [] : ['submit', 'update']

  const interfaces = [...base, ...skip, ...edit]

  const hasInterface = (list: string[]) =>
    list.some((i) => interfaces.includes(i))

  return { interfaces, hasInterface }
}

// We leave below other options because they were kinda hard to find,
// those options are not well documented by the label studio team

// 'review',                // changes the interface to review mode: submit/update -> accept, skip -> reject
// 'infobar',               // n/a
// 'ground-truth',          // n/a, probably works only when 'predictions' data is provided
// 'annotations:history',   // provides a history of annotations in right panel
// 'annotations:tabs',      // adds an exposé-like view of annotation history
// 'annotations:menu',      // n/a
// 'annotations:current',   // n/a
// 'annotations:add-new',   // adds a 'create annotation' button on box that displays current annotation author
// 'annotations:delete',    // adds a delete annotation button in topbar, behaves like delete button in right panel
// 'annotations:view-all',  // n/a, probably related to other annotation interfaces
// 'predictions:tabs',      // shows box with annotation author (why?)
// 'predictions:menu',      // n/a
// 'auto-annotation',       // shows a toggle
// 'edit-history',          // n/a, probably related to other history interfaces
// 'topbar:prevnext',       // shows prev/next buttons in topbar
